.booleanProperty {
  display: flex;
  align-items: center;
  gap: var(--spacingMd);
  min-width: 0;
}
